import React, { useEffect } from 'react';
import JuniorHeader from'../Component/JuniorHeader'
 import { Link } from 'react-router-dom';
const Home = () => {  
   
    useEffect(() => {
        document.title = ' Home - Sacread Heart Kharagpur';  
    }, []); 
  return (
     <>
     <JuniorHeader/> 
     <div className="slider-sec">
     <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
     <div className="carousel-inner">
       <div className="carousel-item active" data-bs-interval="3000"> <img src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/sld.jpg" className="d-block w-100" alt="SHCSKWB" /> </div>
       <div className="carousel-item" data-bs-interval="3000"> <img src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/sld2.jpg" className="d-block w-100" alt="SHCSKWB"/> </div> 
       <div className="carousel-item" data-bs-interval="3000"> <img src="https://webapi.entab.info/api/image/SHCSKWB/public/Images/sld5.jpg" className="d-block w-100" alt="SHCSKWB"/> </div> 
       </div> 
     <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev"> <span className="carousel-control-prev-icon" aria-hidden="true"></span> <span className="visually-hidden">Previous</span> </button> <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next"> <span className="carousel-control-next-icon" aria-hidden="true"></span> <span className="visually-hidden">Next</span> </button>
   </div> 
   <div className="primarysec">
    <Link to="/"> 
      <div className="primarysectext"> High School </div>
   </Link>
</div>
</div>
   <div className="juniorabout">
       <div className="container">
            <div className="row">
                  <div className="col-lg-12">
                       <div class="title"><h2> History</h2></div>
                        <p>In June 1962, His Grace Archbishop Henry D'Souza,
                        then Parish Priest of Sacred Heart Church, Kharagpur began
                        a small Primary School, with 3 teachers and 25 students in
                        the Parochial Hall, known as Sacred Heart Primary School.
                        Late Fr. J. Lazarus S. J. was the first Principal.</p>
                        
                        <p>The School began out of concern for the poor Catholic
                        children of the parish community, and of Kharagpur.
                        Gradually with the able assistance of Late Frs Joachim Osta
                        and Late Gilbert Pinto the Primary School building came up.
                        From 2004, the Primary School began admitting girls too.</p>
                  </div>
            </div>
       </div>
   </div>
     </>
  )
}

export default Home

